import script from "./out-of-stocks.vue?vue&type=script&lang=ts&setup=true"
export * from "./out-of-stocks.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__